import styled from 'styled-components/native'

export const ActivityIndicator = styled.ActivityIndicator`
  margin-top: 50%;
`
